module.exports = __webpack_public_path__ + "img/setting.9b1341aa.png";